import { loadView } from '@/router'

export default [
  {
    path: 'quote',
    name: 'freight-quote',
    component: loadView('Application/Freight/Quote')
  },
  {
    path: 'quote-v3',
    name: 'freight-quote-v3',
    component: loadView('Application/Freight/NewQuote'),
    showInAlfred: true,
    alfredTitle: 'Freight - Quote'
  }
]
